const translations = {
    headline: {
        type: 'text',
        defaultValue: 'Artykuły...',
    },
    subheadline: {
        type: 'text',
        defaultValue: 'Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Nam Nec Fermentum Tortor.',
    },
    'contentList': {
        type: 'text',
        'defaultValue': 'Spis treści',
    },
};

export default translations;
